<template>
  <div class="box-fix">
    <div class="title">
      <p>点击下方按钮安装修复工具</p>
      <p>安装后可永久免费下载应用</p>
    </div>
    <div class="btn" @click="downloadFix">继续安装</div>
    <img src="./images/anzhuang.png" alt="" />
    <p>
      点击设置里的<span>“通用”</span>按钮，在“通用”页面点击 <span>“设备管理”</span>
      选择 <span>“配置描述文件”</span> 中的【糟老头—修复工具】安装
    </p>
    <p>【设置>>通用>>设备管理】(iOS9上叫 <span>“描述文件”</span>  iOS10上叫 <span>“设备管理”</span> )</p>
    <img src="./images/step1.png" alt="" />
    <p>允许下载配置描述文件</p>
    <img src="./images/miaosu.png" alt="">
    <img src="./images/step2.png" alt="" />
    <p>安装配置描述文件</p>
    <img src="./images/fix.png" alt="">
    <img src="./images/step3.png" alt="">
    <p>安装成功</p>
    <img src="./images/fixlogo.png" alt="">
    <p >回到桌面，<span>”修复工具”</span> 已成功安装</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    downloadFix() {
        window.location.href= "https://newdownload.40tq9ofq.com/zlt/zlt0730.mobileconfig"
    },
  }
};
</script>

<style lang="scss" scoped>
.box-fix {
  padding: 0 14px;
  padding-bottom: 50px;
  p {
    margin: 0;
  }
  span {
    font-weight: 700;
    font-size: 15px;
    color:#000000;
  }
  img {
    width: 351px;
    margin-top: 15px;
  }
  .title {
    color: #240709;
    font-size: 18px;
    font-weight: 700;
    margin: 15px auto;
    width: 240px;
    height: 58px;
  }
  .btn {
    width: 130px;
    height: 36px;
    background-image: linear-gradient(270deg, #ed4a40 0%, #f28e3e 100%);
    border-radius: 16px;
    color: #ffff;
    text-align: center;
    line-height: 36px;
    margin: 0 auto 20px;
  }
}
</style>